import React from 'react';
import { Box, Grid } from '@mui/material';

import Card from '../components/shared/Card';
import { matchPathname } from '../Utils';
import { nextStepsURLs } from '../components/shared/Links';
import { buildCards } from '../components/shared/CardContent';

const CardContainer = ({ clientType, confidenceScoreResult, assetAmount }) => {
    const cards = buildCards(clientType, confidenceScoreResult, assetAmount);
    console.log('clientType', clientType);
    console.log('confidenceScoreResult', confidenceScoreResult);
    if(cards.length > 0 ){
        window.metricsData.ric = {
            "score" : confidenceScoreResult,
            "cta": [ cards[0].buttonText,
                     cards[1].buttonText,
                     cards[2].buttonText],
            "retirementAssetAmount": assetAmount
        }}

    return (
        <Box className='b-container' sx={{ inlineSize: 'unset !important' }}>
        {(matchPathname(nextStepsURLs).length) ? (
                    <Grid spacing={4} container sx={{ margin: '48px 0 48px 0px' }}>
                        {cards.map((card, index) =>
                            <Grid
                                item
                                key={index}
                                size={{ 
                                    xs: 12, 
                                    sm: 6, 
                                    md: 6, 
                                    lg: 4 
                                }}
                            >
                                <Card
                                    key={card.buttonText}
                                    title={card.title}
                                    text={card.text}
                                    id={card.id}
                                    buttonText={card.buttonText}
                                    variant={card.variant}
                                    image={card.image}
                                    url={card.url}
                                />
                            </Grid>
                        )}
                    </Grid>
            ) :
            (
                ''
            )
        }
        </Box>
    );
};

export default CardContainer;
